import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core'
import { TranslocoDirective } from '@jsverse/transloco'
import { SearchGameItem } from '@/features/search/search.model'
import { BaseIconComponent, LUCIDE_ICONS } from '@/shared/components/base/base-icon/base-icon.component'
import { SiteConfigService } from '@/services/site-config.service'

/**
 * One game hit: artwork, name, where it lives, how it is liked and paid, who
 * made it, and how many are playing it now.
 */
@Component({
	selector: 'game-panel-card',
	templateUrl: './game-panel-card.component.html',
	styleUrls: ['./panel-card.css', './game-panel-card.component.css'],
	imports: [TranslocoDirective, BaseIconComponent],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class GamePanelCardComponent {
	readonly item = input.required<SearchGameItem>()

	protected readonly PlayIcon = LUCIDE_ICONS['CirclePlay']

	private readonly siteConfigService = inject(SiteConfigService)

	protected readonly followers = computed(() => this.format(this.item().followers, 0))
	protected readonly playing = computed(() => this.format(this.item().playing, 0))

	// The API sends two decimals (96.50); the row shows only the ones that say something.
	protected readonly rtp = computed(() => {
		const rtp = this.item().rtp

		return rtp === null ? null : this.format(rtp, 2)
	})

	private format(value: number, maximumFractionDigits: number): string {
		return new Intl.NumberFormat(this.siteConfigService.activeLocale(), { maximumFractionDigits }).format(value)
	}
}
